<a class="container" [routerLink]="['/marketplace', member.id]">
    <h3 class="heading">{{ member.firstName }} {{ member.lastName }}</h3>
    <div *ngIf="member.lastSeenOn" class="last-online">
        <span class="last-online__dot" [class.last-online__dot--active]="isOnlineToday"></span>
        {{ member.lastSeenOn | relativeTime }}
    </div>
    <figure aria-hidden="true" class="avatar">
        <img [src]="member.profilePicture.path" alt="">
    </figure>
    <p class="contact">
        <span class="sr-only" i18n="sr-only@@employment.teamMember.telefon">Telefon:</span>
        <span class="icon icon-phone"></span>
        <a href="tel:{{ member.phoneNumber }}" (click)="$event.stopPropagation()">
            {{ member.phoneNumber }}
        </a>
        <br>
        <span class="sr-only" i18n="sr-only@@employment.teamMember.email">E-Mail:</span>
        <span class="icon icon-mail"></span>
        <a href="mailto:{{ member.emailAddress }}" (click)="$event.stopPropagation()">{{ member.emailAddress }}</a>
    </p>
    <div class="services" *ngIf="offer">
        <span class="sr-only" i18n="sr-only@@employment.teamMember.assistanceServices">Assistenzdienstleistungen:</span>
        <app-tag-list [tags]="offer.assistanceServices" center="true"></app-tag-list>
    </div>
</a>
